var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExceptionVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 269.291,
    height: 255.118,
    viewBox: "0, 0, 269.291, 255.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259,0.451 L259,254.315 L11.248,254.315 L11.248,0.451 L259,0.451 z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.456,169.471 C205.306,174.167 203.6,177.03 203.6,177.03 C203.6,177.03 192.069,175.283 189.253,185.09 C187.613,190.803 188.009,195.399 190.885,199.071 L190.301,201.937 C185.878,194.246 181.07,187.119 178.488,184.3 C178.252,184.04 177.951,183.779 177.62,183.524 L177.624,183.45 C177.156,182.945 176.013,182.281 174.369,181.571 C173.306,181.04 172.482,180.699 172.482,180.699 L172.463,180.812 C172.065,180.666 171.646,180.519 171.216,180.373 C184.158,178.9 195.09,174.481 204.003,168.022 C204.207,168.495 204.367,168.976 204.456,169.471 M232.935,114.972 C233.195,112.521 233.354,110.055 233.409,107.585 C233.518,108.175 233.627,108.764 233.712,109.362 C233.712,109.362 257.742,62.717 216.485,34.677 C216.485,34.677 204.978,3.876 143.899,11.619 C136.035,11.836 122.605,11.217 113.13,5.498 C113.13,5.498 110.604,11.869 118.896,18.118 C78.443,36.602 84.375,85.645 85.602,93.465 C85.274,95.353 85.007,97.251 84.803,99.152 C78.898,100.221 72.985,103.957 71.877,114.335 C70.694,125.409 76.262,131.923 88.738,134.843 C95.918,154.99 112.02,171.769 138.487,178.184 C131.291,179.601 125.643,181.87 124.426,183.152 L124.436,183.41 C124.414,183.425 124.396,183.435 124.374,183.45 C115.655,189.124 104.438,210.145 83.741,264.263 L84.893,264.845 C79.936,269.036 62.535,284.407 65.106,291.604 C68.099,299.98 89.777,279.517 89.777,279.517 C89.777,279.517 86.957,286.222 90.741,287.911 C95.71,290.127 96.089,283.356 98.188,276.19 C98.867,273.88 98.81,271.624 98.402,269.575 L119.586,233.891 L109.754,293.895 L112.469,293.895 C111.872,298.983 111.521,304.352 111.349,309.743 L111.258,309.848 C111.288,309.83 111.316,309.81 111.347,309.792 C110.564,334.386 113.473,359.344 113.473,359.344 L124.301,359.404 L125.75,369.412 L125.749,369.412 L132.95,419.164 L132.951,419.164 C130.763,420.008 128.748,421.269 127.292,423.144 C125.93,424.9 125.237,426.293 124.926,427.388 L124.923,427.389 C122.554,431.632 124.329,433.409 124.329,433.409 L146.96,433.341 L146.974,430.949 L147.039,419.243 L147.039,419.223 L147.047,417.792 C147.047,417.792 147.033,417.79 147.027,417.79 L146.652,369.529 L146.574,359.529 L148.205,359.538 L150.081,325.242 L150.293,314.033 L150.38,325.244 L151.871,359.558 L153.503,359.567 L153.313,369.566 L152.396,417.82 C152.392,417.821 152.379,417.822 152.379,417.822 L152.371,419.147 L152.369,419.273 L152.371,419.273 L152.306,430.979 L152.292,433.371 L174.919,433.692 C174.919,433.692 176.717,431.935 174.392,427.665 L174.391,427.665 C174.092,426.566 173.415,425.167 172.071,423.395 C170.637,421.505 168.637,420.221 166.458,419.352 L174.216,369.683 L175.776,359.692 L186.604,359.753 C186.604,359.753 189.791,334.829 189.285,310.228 C189.314,310.248 189.343,310.267 189.373,310.286 L189.283,310.18 C189.168,304.638 188.867,299.114 188.298,293.895 L192.357,293.895 L181.958,230.43 C185.16,233.845 193.972,241.474 201.577,231.741 C207.072,224.708 208.519,213.862 208.436,203.984 C210.887,203.028 212.474,201.832 212.474,201.832 C212.474,201.832 219.864,195.02 215.102,181.201 C215.102,181.201 217.2,172.184 213.207,163.902 C212.762,162.979 212.285,162.146 211.792,161.376 C215.525,157.641 218.782,153.492 221.551,149.027 C234.363,148.808 241.18,143.617 242.363,132.543 C243.471,122.165 238.48,117.264 232.935,114.972",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.456,169.471 C205.306,174.167 203.6,177.03 203.6,177.03 C203.6,177.03 192.069,175.283 189.253,185.09 C187.613,190.803 188.009,195.399 190.885,199.071 L190.301,201.937 C185.878,194.246 181.07,187.119 178.488,184.3 C178.252,184.04 177.951,183.779 177.62,183.524 L177.624,183.45 C177.156,182.945 176.013,182.281 174.369,181.571 C173.306,181.04 172.482,180.699 172.482,180.699 L172.463,180.812 C172.065,180.666 171.646,180.519 171.216,180.373 C184.158,178.9 195.09,174.481 204.003,168.022 C204.207,168.495 204.367,168.976 204.456,169.471 z M232.935,114.972 C233.195,112.521 233.354,110.055 233.409,107.585 C233.518,108.175 233.627,108.764 233.712,109.362 C233.712,109.362 257.742,62.717 216.485,34.677 C216.485,34.677 204.978,3.876 143.899,11.619 C136.035,11.836 122.605,11.217 113.13,5.498 C113.13,5.498 110.604,11.869 118.896,18.118 C78.443,36.602 84.375,85.645 85.602,93.465 C85.274,95.353 85.007,97.251 84.803,99.152 C78.898,100.221 72.985,103.957 71.877,114.335 C70.694,125.409 76.262,131.923 88.738,134.843 C95.918,154.99 112.02,171.769 138.487,178.184 C131.291,179.601 125.643,181.87 124.426,183.152 L124.436,183.41 C124.414,183.425 124.396,183.435 124.374,183.45 C115.655,189.124 104.438,210.145 83.741,264.263 L84.893,264.845 C79.936,269.036 62.535,284.407 65.106,291.604 C68.099,299.98 89.777,279.517 89.777,279.517 C89.777,279.517 86.957,286.222 90.741,287.911 C95.71,290.127 96.089,283.356 98.188,276.19 C98.867,273.88 98.81,271.624 98.402,269.575 L119.586,233.891 L109.754,293.895 L112.469,293.895 C111.872,298.983 111.521,304.352 111.349,309.743 L111.258,309.848 C111.288,309.83 111.316,309.81 111.347,309.792 C110.564,334.386 113.473,359.344 113.473,359.344 L124.301,359.404 L125.75,369.412 L125.749,369.412 L132.95,419.164 L132.951,419.164 C130.763,420.008 128.748,421.269 127.292,423.144 C125.93,424.9 125.237,426.293 124.926,427.388 L124.923,427.389 C122.554,431.632 124.329,433.409 124.329,433.409 L146.96,433.341 L146.974,430.949 L147.039,419.243 L147.039,419.223 L147.047,417.792 C147.047,417.792 147.033,417.79 147.027,417.79 L146.652,369.529 L146.574,359.529 L148.205,359.538 L150.081,325.242 L150.293,314.033 L150.38,325.244 L151.871,359.558 L153.503,359.567 L153.313,369.566 L152.396,417.82 C152.392,417.821 152.379,417.822 152.379,417.822 L152.371,419.147 L152.369,419.273 L152.371,419.273 L152.306,430.979 L152.292,433.371 L174.919,433.692 C174.919,433.692 176.717,431.935 174.392,427.665 L174.391,427.665 C174.092,426.566 173.415,425.167 172.071,423.395 C170.637,421.505 168.637,420.221 166.458,419.352 L174.216,369.683 L175.776,359.692 L186.604,359.753 C186.604,359.753 189.791,334.829 189.285,310.228 C189.314,310.248 189.343,310.267 189.373,310.286 L189.283,310.18 C189.168,304.638 188.867,299.114 188.298,293.895 L192.357,293.895 L181.958,230.43 C185.16,233.845 193.972,241.474 201.577,231.741 C207.072,224.708 208.519,213.862 208.436,203.984 C210.887,203.028 212.474,201.832 212.474,201.832 C212.474,201.832 219.864,195.02 215.102,181.201 C215.102,181.201 217.2,172.184 213.207,163.902 C212.762,162.979 212.285,162.146 211.792,161.376 C215.525,157.641 218.782,153.492 221.551,149.027 C234.363,148.808 241.18,143.617 242.363,132.543 C243.471,122.165 238.48,117.264 232.935,114.972 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.541,47.393 C27.541,47.393 17.349,35.641 23.583,24.751 C30.499,12.668 60.616,10.329 64.311,31.204 C68.005,52.08 45.296,57.878 45.296,57.878 L48.832,71.092",
    fillOpacity: 0,
    stroke: "#919ED0",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.428,86.73 L53.169,88.969",
    fillOpacity: 0,
    stroke: "#919ED0",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.062,176.926 C138.693,176.856 126.3,181.177 124.426,183.152 L125.487,210.408 L176.258,210.692 L177.624,183.45 C175.774,181.454 163.43,176.995 151.062,176.926",
    fill: "#FFC46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.062,176.926 C138.693,176.856 126.3,181.177 124.426,183.152 L125.487,210.408 L176.258,210.692 L177.624,183.45 C175.774,181.454 163.43,176.995 151.062,176.926 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.328,181.705 C127.328,181.705 126.491,182.063 124.374,183.45 C115.655,189.124 104.438,210.145 83.741,264.263 L97.446,271.186 L129.809,216.671",
    fill: "#FFC46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.328,181.705 C127.328,181.705 126.491,182.063 124.374,183.45 C115.655,189.124 104.438,210.145 83.741,264.263 L97.446,271.186 L129.809,216.671",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.921,201.884 L160.412,183.756 L141.583,183.65 z",
    fill: "#DEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.921,201.884 L160.412,183.756 L141.583,183.65 L150.921,201.884 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,175.912 L156.747,162.504 L151.162,158.827 L145.536,162.44 L144.192,175.835 L139.649,177.958 C139.649,177.958 139.815,187.915 150.999,187.977 C162.183,188.04 162.461,178.086 162.461,178.086 z",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,175.912 L156.747,162.504 L151.162,158.827 L145.536,162.44 L144.192,175.835 L139.649,177.958 C139.649,177.958 139.815,187.915 150.999,187.977 C162.183,188.04 162.461,178.086 162.461,178.086 L157.94,175.912 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,100.053 C97.85,100.053 74.211,92.482 71.877,114.335 C70.504,127.191 78.203,133.915 95.283,135.986",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85,100.053 C97.85,100.053 74.211,92.482 71.877,114.335 C70.504,127.191 78.203,133.915 95.283,135.986",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.962,116.502 C80.962,116.502 84.287,115.377 87.304,115.718",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.962,116.502 C80.962,116.502 84.287,115.377 87.304,115.718",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.991,113.097 C219.991,113.097 244.696,110.69 242.363,132.543 C240.989,145.399 232.046,150.346 214.913,148.763",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.991,113.097 C219.991,113.097 244.696,110.69 242.363,132.543 C240.989,145.399 232.046,150.346 214.913,148.763",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.025,132.742 C233.025,132.742 230.013,130.94 226.992,130.637",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.025,132.742 C233.025,132.742 230.013,130.94 226.992,130.637",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.042,180.347 C47.328,169.27 73.628,18.042 167.308,28.047 C260.986,38.052 254.756,191.425 151.042,180.347",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.042,180.347 C47.328,169.27 73.628,18.042 167.308,28.047 C260.986,38.052 254.756,191.425 151.042,180.347 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.147,118.509 C192.469,124.867 189.819,129.799 187.229,129.523 C184.642,129.247 183.094,123.866 183.771,117.508 C184.451,111.149 187.102,106.217 189.689,106.493 C192.279,106.77 193.827,112.15 193.147,118.509",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.947,111.012 C122.269,117.37 123.816,122.75 126.405,123.026 C128.993,123.304 131.644,118.371 132.322,112.013 C133.002,105.654 131.453,100.273 128.865,99.997 C126.275,99.721 123.626,104.653 122.947,111.012",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.221,133.578 C153.221,133.578 151.636,138.28 155.879,138.463",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,43.959 C124.48,43.959 135.515,67.765 167.087,78.177 L166.652,53.994 C166.652,53.994 174.608,73.175 204.405,81.386 L203.091,65.931 C203.091,65.931 230.024,83.255 233.712,109.362 C233.712,109.362 257.742,62.717 216.485,34.677 C216.485,34.677 204.365,2.207 138.923,12.314 C71.855,22.672 85.782,94.533 85.782,94.533 C85.782,94.533 93.839,57.783 124.48,43.959",
    fill: "#997B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,43.959 C124.48,43.959 135.515,67.765 167.087,78.177 L166.652,53.994 C166.652,53.994 174.608,73.175 204.405,81.386 L203.091,65.931 C203.091,65.931 230.024,83.255 233.712,109.362 C233.712,109.362 257.742,62.717 216.485,34.677 C216.485,34.677 204.365,2.207 138.923,12.314 C71.855,22.672 85.782,94.533 85.782,94.533 C85.782,94.533 93.839,57.783 124.48,43.959 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.335,11.2 C150.335,11.2 127.302,14.051 113.13,5.498 C113.13,5.498 109.856,13.735 122.945,20.664",
    fill: "#997B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.335,11.2 C150.335,11.2 127.302,14.051 113.13,5.498 C113.13,5.498 109.856,13.735 122.945,20.664",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.431,80.411 C126.556,74.711 133.873,75.242 137.163,80.537",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.136,88.496 C197.285,82.264 190.021,81.238 185.688,85.72",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.508,214.879 L181.891,228.858 C192.394,238.327 201.963,234.292 199.842,223.18 C197.923,213.131 183.689,189.979 178.488,184.3 C176.86,182.513 172.482,180.699 172.482,180.699",
    fill: "#FFC46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.508,214.879 L181.891,228.858 C192.394,238.327 201.963,234.292 199.842,223.18 C197.923,213.131 183.689,189.979 178.488,184.3 C176.86,182.513 172.482,180.699 172.482,180.699",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.953,208.554 L194.863,179.534 L205.843,180.844 C205.843,180.844 213.93,215.932 201.577,231.741 C192.088,243.886 180.711,228.992 180.711,228.992",
    fill: "#FFC46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.953,208.554 L194.863,179.534 L205.843,180.844 C205.843,180.844 213.93,215.932 201.577,231.741 C192.088,243.886 180.711,228.992 180.711,228.992",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.426,204.353 L109.754,293.895 L192.357,293.895 L177.686,204.353",
    fill: "#FFC46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.426,204.353 L109.754,293.895 L192.357,293.895 L177.686,204.353",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.717,146.253 C159.692,146.757 164.162,170.461 152.058,169.236 C139.953,168.012 149.741,145.75 154.717,146.253",
    fill: "#F09A96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.717,146.253 C159.692,146.757 164.162,170.461 152.058,169.236 C139.953,168.012 149.741,145.75 154.717,146.253 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.474,201.832 C212.474,201.832 219.864,195.02 215.102,181.201 C215.102,181.201 217.2,172.184 213.207,163.902 C209.214,155.621 202.943,153.514 199.822,157.319 C196.7,161.126 203.606,164.775 204.456,169.471 C205.306,174.167 203.6,177.03 203.6,177.03 C203.6,177.03 192.069,175.283 189.253,185.09 C186.838,193.501 188.821,199.499 196.665,203.675 C204.509,207.849 212.474,201.832 212.474,201.832",
    fill: "#FFECD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.474,201.832 C212.474,201.832 219.864,195.02 215.102,181.201 C215.102,181.201 217.2,172.184 213.207,163.902 C209.214,155.621 202.943,153.514 199.822,157.319 C196.7,161.126 203.606,164.775 204.456,169.471 C205.306,174.167 203.6,177.03 203.6,177.03 C203.6,177.03 192.069,175.283 189.253,185.09 C186.838,193.501 188.821,199.499 196.665,203.675 C204.509,207.849 212.474,201.832 212.474,201.832 z",
    fillOpacity: 0,
    stroke: "#666666",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceptionVector2);
export default __webpack_public_path__ + "static/media/exception_vector_2.743480a326728133a0ac4576420a9834.svg";
export { ForwardRef as ReactComponent };